export default [
  {
    text:
      "Ни искусство, ни мудрость не могут быть достигнуты, если им не учиться.",
    author: "Демокрит"
  },
  {
    text:
      "Не стыдись учиться в зрелом возрасте: лучше научиться поздно, чем никогда.",
    author: "Эзоп"
  },
  {
    text:
      "Учитесь так, словно вы постоянно ощущаете нехватку своих знаний, и так, словно вы постоянно боитесь растерять свои знания",
    author: "Конфуций"
  },
  {
    text: " Надо много учиться, чтобы осознать, что знаешь мало.",
    author: "Мишель де Монтень"
  },
  {
    text:
      "Ученик никогда не превзойдет учителя, если видит в нем образец, а не соперника.",
    author: "Виссарион Григорьевич Белинский"
  },
  {
    text:
      "Желание высказаться почти всегда бывает сильнее, чем желание чему-нибудь научиться.",
    author: "Дмитрий Иванович Писарев"
  },
  {
    text: "Ученье свет, а неученье — тьма. Дело мастера боится.",
    author: "Александр Васильевич Суворов"
  },
  {
    text: "Пока мы способны учиться, нет никаких причин для отчаяния разума.",
    author: "Карл Раймунд Поппер "
  },
  {
    text: "Ученость — это сладкий плод горького корня.",
    author: "Исократ"
  },
  {
    text:
      "Хуже всего то, что кто смолоду плохо обучен, тот до старости в этом не сознается.",
    author: "Петроний Арбитр Гай"
  },
  {
    text: "Учиться никогда не поздно. Осуждают то, чего не понимают.",
    author: "Квинтилиан"
  },
  {
    text: " Знать хотят многие, добывать знания — немногие.",
    author: "Неизвестный автор"
  }
];
